import { render, staticRenderFns } from "./DefinitionList.vue?vue&type=template&id=1130c9f4"
import script from "./DefinitionList.vue?vue&type=script&lang=js"
export * from "./DefinitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1130c9f4')) {
      api.createRecord('1130c9f4', component.options)
    } else {
      api.reload('1130c9f4', component.options)
    }
    module.hot.accept("./DefinitionList.vue?vue&type=template&id=1130c9f4", function () {
      api.rerender('1130c9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/DefinitionList.vue"
export default component.exports